"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = profileRequest;

var _axios = _interopRequireDefault(require("axios"));

var _reactCookies = _interopRequireDefault(require("react-cookies"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var ENDPOINT = process.env.API_INTEGRATION_ENDPOINT || 'https://api-integration.stelecom.ru/v1';

function profileRequest(citydomain, accessToken, billingHost) {
  var token = accessToken || _reactCookies["default"].load('ACCESS_TOKEN');

  var domain = citydomain || _reactCookies["default"].load('citydomain');

  var headers = {
    'Domain': domain,
    'Authorization': "Bearer ".concat(token),
    'Content-Type': 'application/json'
  };

  if (billingHost) {
    headers['Billing-Host'] = billingHost;
  }

  return _axios["default"].create({
    baseURL: ENDPOINT,
    headers: headers
  });
}